'use client'
import { createTheme } from '@mui/material'
import { getShadows } from './modules/getShadows'
import { mixins } from './modules/mixins'
import { MuiComponentOverrides } from './modules/MuiComponentOverrides'
import { palette } from './modules/palette'
import { spacing } from './modules/spacing'
import { DEFAULT_FONT_FAMILY, typography } from './modules/typography'

export { DEFAULT_FONT_FAMILY }

function composeTheme() {
  const theme = createTheme({
    spacing,
    typography,
    palette,
    mixins,
    components: MuiComponentOverrides,
  })

  // compose the theme to "enhance it", a la: https://mui.com/material-ui/customization/theming/#api
  return createTheme(theme, {
    shadows: getShadows(theme),
  })
}

/**
 * @deprecated Retrieve the theme from context (within an `sx` prop, or a `styled` component, or with `useTheme`) rather than importing directly
 */
export const theme = composeTheme()
